/**
 *
 * All regestered route for sidebar only.
 *
 */

 import Dashboard from "views/Dashboard.js";
 import Agenda from 'views/Agenda/Agenda.js';
 import AuditIndex from 'views/Audit/Auditee/Index.js';
 import Document from 'views/Document/Document.js';

 /** Only handle authenticated user */
const layout = {
  layout: '/auditee',
  user: true,
};

 var routes = [
   {
     path: "/dashboard",
     ...layout,
     name: "Dashboard",
     icon: "nc-icon nc-chart-pie-35",
     component: Dashboard,
   },
   {
    path: "/audits",
    ...layout,
    name: "Audit",
    icon: "nc-icon nc-notes",
    component: AuditIndex,
   },
   {
     path: "/agenda",
     ...layout,
     name: "Agenda",
     state: "openTables",
     icon: "nc-icon nc-paper-2",
     component: Agenda,
   },
   {
    path: "/document",
    ...layout,
    name: "Document",
    icon: "nc-icon nc-single-copy-04",
    component: Document,
  },
 ];

 export default routes;
